<div class="product-detail-container" *ngIf="product && masterProduct">
  <div class="banner" *ngIf="isHeightEffected">
    <div class="content">
      <kion-warning-banner
        class="lr"
        [header]="'pdp.banner.liftHeightWarning.headline' | translate"
        [body]="'pdp.banner.liftHeightWarning.description' | translate"
        [showIcon]="true"
        [closable]="true"
      >
        <div icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path fill="#222" fill-rule="evenodd" d="M8 0c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm0 1.143C4.219 1.143 1.143 4.219 1.143 8S4.219 14.857 8 14.857 14.857 11.781 14.857 8 11.781 1.143 8 1.143zm.571 5.143V12H7.43V6.286H8.57zm0-2.286v1.143H7.43V4H8.57z"></path>
          </svg>
        </div>
        <div close (click)="closeBanner()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M9.933 1.076L8.923 0.066 5 3.99 1.077 0.066 0.067 1.076 3.99 5 0.067 8.924 1.077 9.934 5 6.01 8.923 9.934 9.933 8.924 6.01 5z" transform="translate(5 5)"></path>
          </svg>
        </div>
      </kion-warning-banner>
    </div>
  </div>
  <div class="content">
    <div class="detail">
      <div class="wrapper">
        <div class="carousel">
          <kion-product-carousel
            [images]="product.images"
            [videos]="product.videos"
          ></kion-product-carousel>
        </div>
        <div class="description">
          <div class="header">
            <div class="article-no">
              {{ 'pdp.details.articleNumber' | translate }} {{ product.code }}
            </div>
            <h1 class="title">
              {{ product.name }}
            </h1>
          </div>
          <div class="body">
            <div class="icons" *ngIf="icons">
              <kion-icon-bar [icons]="icons" scale="extra-large"></kion-icon-bar>
            </div>
            <div class="description-text">
              {{ product.summary }}
            </div>
            <div class="more-details" (click)="scrollToProductInfo(productInfo)">
              {{ 'pdp.details.moreDetails' | translate }}
            </div>
            <div class="variant-selection" *ngIf="masterProduct.variants?.length > 0">
              <kion-variant-selection
                *ngFor="let variant of variants$ | async"
                [variant]="variant"
                (select)="selectVariant($event)"
              ></kion-variant-selection>
            </div>
            <div class="contract" *ngIf="hasContract">
              <kion-checkbox [boxes]="contractBox" (requiredSelected)="contractSelected($event)"></kion-checkbox>
              <div class="description-box">
                {{ 'pdp.details.serviceContract.description' | translate }}
              </div>
            </div>
            <div class="actions">
              <div class="pricing" *ngIf="product.price; else priceOnRequest">
                <div class="price">
                  <kion-price [price]="price" [strikedPrice]="strikedPrice" [sameLine]="true" type="extra-large"></kion-price>
                </div>
                <div class="vat-switch">
                  <kion-drop-down [options]="vatSwitchOptions" [title]="selectedVatSwitchTitle" [showDropDownOnClick]="true" (selected)="selectVatSwitchOption($event)"></kion-drop-down>
                </div>
              </div>
              <ng-template #priceOnRequest>
                <div class="pricing on-request">
                  <span> {{ 'pdp.details.priceOnRequest.description' | translate }} </span>
                </div>
              </ng-template>
              <div class="action {{ product.price ? '' : 'on-request'}}" [formGroup]="form">
                <kion-quantity-selector
                  *ngIf="product.price"
                  [formGroup]="form"
                ></kion-quantity-selector>
                <kion-button *ngIf="product.price" [title]="'pdp.details.button.addToBasket' | translate" [isLoading]="addingToBasket" [showTextWhileLoading]="true" (clicked)="addToBasket()" [disabled]="isMasterButHasVariants"  mode="primary"></kion-button>
                <kion-button *ngIf="!product.price" [title]="'pdp.details.button.priceOnRequest' | translate" [isLoading]="addingToBasket" [showTextWhileLoading]="true" (clicked)="priceOnRequestCall()" [disabled]="isMasterButHasVariants"  mode="primary"></kion-button>
              </div>
              <div class="delivery-information" *ngIf="product.price;">
                <div class="icon">
                  <img src="./assets/icons/delivery_icon.svg" alt="deliver_icon" title="delivery_icon" />
                </div>
                <div class="text">
                  <kion-delivery-time [product]="product"></kion-delivery-time>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="product-information-wrapper" #productInfo>
      <svg viewBox="0 0 200 12" class="tilt">
        <path d="M 0,12 200,0 v 12 H 0 Z"></path>
      </svg>
      <div class="wrapper">
        <div class="product-information">
          <kion-product-information
            [info]="product?.description || masterProduct?.masterProduct.description"
            [usps]="product?.usps ? product?.usps.split('*') : masterProduct?.masterProduct?.usps?.split('*')"
            [applications]="product?.applications || masterProduct?.masterProduct?.applications"
          ></kion-product-information>
        </div>
        <div class="benefits">
          <kion-benefit-data
            *ngIf="benefits$ | async as benefits; else fallbackBenefits"
            [benefits]="benefits"
          ></kion-benefit-data>
          <ng-template #fallbackBenefits>
            <kion-benefit-data
              *ngIf="benefitsFallback$ | async as benefits"
              [benefits]="benefits"
            ></kion-benefit-data>
          </ng-template>
        </div>
        <div class="technical" *ngIf="technicalDetails.length > 0">
          <kion-technical-data
            *ngIf="technicalDetails?.length > 0; else fallbackTechnicalDetails"
            [technicalDetails]="technicalDetails"
          ></kion-technical-data>
          <ng-template #fallbackTechnicalDetails>
            <kion-technical-data
              *ngIf="technicalDetailsFallback as technicalDetails"
              [technicalDetails]="technicalDetails"
            ></kion-technical-data>
          </ng-template>
        </div>
        <div class="downloads">
          <kion-downloads
            *ngIf="product.dataSheets as datasheets; else fallbackDatasheets"
            [dataSheets]="datasheets"
          ></kion-downloads>
          <ng-template #fallbackDatasheets>
            <kion-downloads
              *ngIf="masterProduct?.masterProduct?.dataSheets as datasheets"
              [dataSheets]="datasheets"
            ></kion-downloads>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
